export const WIKI_ARTICLE_QUERY_KEY = ["wiki-article"];
export const WIKI_CATEGORIES_QUERY_KEY = ["wiki-categories"];
export const WIKI_DRAFT_ARTICLES_QUERY_KEY = ["wiki-draft-articles"];
export const WIKI_SAVED_ARTICLES_QUERY_KEY = ["wiki-saved-articles"];
export const WIKI_ARTICLES_BY_CATEGORY_QUERY_KEY = [
  "wiki-articles-by-category",
];
export const WIKI_FEEDBACK_QUERY_KEY = ["wiki-feedback"];
export const WIKI_MY_FEEDBACK_QUERY_KEY = ["wiki-my-feedback"];
